// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'table-disc';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.531 10.063c0 .209.096.416.283.61s.461.368.806.516c.346.148.756.266 1.207.346s.935.121 1.423.121.972-.041 1.423-.121.861-.198 1.207-.346c.345-.148.619-.323.806-.517s.283-.4.283-.61c0-.209-.096-.416-.283-.61s-.461-.368-.806-.516a5.565 5.565 0 0 0-1.207-.346c-.451-.08-.935-.121-1.423-.121s-.972.041-1.423.121c-.451.08-.861.198-1.207.346-.345.148-.619.323-.806.517s-.283.4-.283.61z' />
    <path d='M9.531 10.063v2.656c0 .88 1.665 1.594 3.719 1.594s3.719-.714 3.719-1.594v-2.656' />
    <path d='M9.531 12.718v2.657c0 .88 1.665 1.594 3.719 1.594s3.719-.714 3.719-1.594v-2.656M1.031 8.824h6.375M6.344 12.72H2.448a1.417 1.417 0 0 1-1.417-1.417V2.449a1.417 1.417 0 0 1 1.417-1.417h10.625a1.417 1.417 0 0 1 1.417 1.417v3.966M1.031 4.928H14.49m-8.393 0v4.781m4.232-4.781v1.75' />
  </g>
);

export const viewBox = '0 0 18 18';
